import { RootState } from "../../../../../redux/store";
import * as constants from "./constants";

export const isItemsLoading = (state:RootState) => state.taskTypes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.taskTypes.actionsLoading;
export const getItems = (state:RootState) => state.taskTypes.items;
export const getItemsCount = (state:RootState) => state.taskTypes.itemsCount;
export const getItemForEdit = (state:RootState) => state.taskTypes.itemForEdit;
export const getDropDownItems = (state:RootState) => state.taskStatuses.dropDownItems;
export const getDropDownItemsLoading = (state:RootState) => state.taskStatuses.dropDownLoading;
export const getError = (state:RootState) => state.taskTypes.error;
export const getErrorAction = (state:RootState) => state.taskTypes.errorAction;
export const validationErrors = (state:RootState) => state.taskTypes.validationErrors;

export const getTaskTypeSurveys = (state:RootState) => state.taskTypes[constants.TASK_TYPE_SURVEYS];
export const getTaskTypeSurveysLoading = (state:RootState) => state.taskTypes[constants.TASK_TYPE_SURVEYS_LOADING];
